import { FontLoader, GLTFLoader, TechnicolorShader } from "three/examples/jsm/Addons.js";
import EventEmitter from "./EventEmitter.js";
import { TextureLoader } from "three";
import LowLatencySound from "./LowLatencySound.js";

export default class Resources extends EventEmitter {

    constructor(sources) {

        super()
        this.sources = sources


        this.items = {}
        this.toLoad = this.sources.length
        this.loaded = 0


        this.setLoaders()
        this.startLoading()
    }

    setLoaders() {
        this.loaders = {}

        this.loaders.gltfLoader = new GLTFLoader()
        this.loaders.textureLoader = new TextureLoader()
        this.loaders.fontLoader = new FontLoader()
    }

    startLoading() {

        for (const source of this.sources) {

            if (source.type === "gltfLoader") {
                this.loaders.gltfLoader.load(
                    source.path,
                    (file) => {
                        this.sourceLoaded(source, file)
                    }
                )
            }
            else if (source.type == "texture") {
                this.loaders.textureLoader.load(
                    source.path,
                    (file) => {
                        this.sourceLoaded(source, file)
                    }
                )
            }
            else if (source.type == "font") {
                this.loaders.fontLoader.load(
                    source.path,
                    (font) => {
                        this.sourceLoaded(source, font)
                    }
                )
            }
            else if (source.type === "audio") {
                const audio = new LowLatencySound(source.path)
                audio.readyPromise
                    .catch(() => {})
                    .finally(() => {
                        this.sourceLoaded(source, audio)
                    })
            }

        }
    }

    sourceLoaded(source, file) {
        this.items[source.name] = file

        this.loaded++

        this.trigger("progress", [this.loaded, this.toLoad, source.name])

        if (this.loaded === this.toLoad) {
            this.trigger("ready")
        }
    }
}
